@if (showLegacyComponent && !showEditor) {
  <lib-timeclock-check-legacy></lib-timeclock-check-legacy>
} @else if (!showEditor) {
  <lib-timeclock-check-v2
    [selCalendarId]="selCalendarId"
    (editTimeclockFile)="displayEditor($event)"></lib-timeclock-check-v2>
} @else if (showEditor) {
  <lib-timeclock-editor
    [selCalendarId]="selCalendarId"
    [header]="fileToEdit"
    (goBack)="hideEditor()"></lib-timeclock-editor>
}
